import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { faCheck } from "@fortawesome/pro-regular-svg-icons/faCheck";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Box, styled, Tooltip } from "@mui/material";
import { ConditionalWrapper } from "../../Utils";
import { checkContrast, colorStateToRgbaString } from "../ColorPicker";
export const ColorButton = (props) => (_jsx(ConditionalWrapper, { condition: !!props.tooltip, WrapperComponent: ({ children }) => (_jsx(Tooltip, { arrow: true, placement: "top", title: props.tooltip, PopperProps: {
            modifiers: [
                {
                    name: "offset",
                    options: {
                        offset: [0, -6]
                    }
                }
            ]
        }, children: children })), children: _jsx(StyledColorButton, { "data-trackingid": props.dataTrackingId, "data-testid": props.dataTestId, "aria-selected": props.selected, disabled: props.disabled, onClick: props.onClick, children: _jsx(Box, { sx: colorButtonSxProps(typeof props.color === "string"
                ? props.color
                : colorStateToRgbaString(props.color), props.selected && props.showCheckmark), children: props.selected && props.showCheckmark
                ? _jsx(FontAwesomeIcon, { icon: faCheck })
                : _jsx(_Fragment, {}) }) }) }));
const StyledColorButton = styled("button")(({ theme }) => ({
    background: "unset",
    padding: "unset",
    border: "none",
    outline: "none",
    width: "30px",
    height: "30px",
    borderRadius: "15px",
    boxSizing: "border-box",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    transition: "all 150ms linear",
    "&:disabled": {
        cursor: "inherit"
    },
    "&:not([disabled])": {
        cursor: "pointer"
    },
    "&:hover": {
        backgroundColor: theme.palette.action.hover
    },
    "&[aria-selected=true]": {
        border: `1px solid ${theme.palette.primary.main}`
    }
}));
const colorButtonSxProps = (predefinedColor, showCheckmark) => (Object.assign(Object.assign({ width: "24px", height: "24px", backgroundColor: (theme) => predefinedColor === "transparent" ? theme.palette.background.paper : predefinedColor, color: (theme) => predefinedColor === "transparent" || checkContrast(predefinedColor, "#ffffff") <= 3
        ? theme.palette.primary.main
        : theme.palette.common.white, borderRadius: "12px", border: (theme) => `1px solid ${theme.palette.divider}`, boxSizing: "border-box", display: "flex", alignItems: "center", justifyContent: "center", position: "relative" }, predefinedColor === "transparent" ? {
    "&::before": {
        content: "''",
        position: "absolute",
        width: "1px",
        height: showCheckmark ? "10px" : "23px",
        left: showCheckmark ? "6px" : "10px",
        top: showCheckmark ? "2px" : 0,
        backgroundColor: (theme) => theme.palette.error.main,
        transform: "rotate(-45deg)"
    },
    "&::after": showCheckmark ? {
        content: "''",
        position: "absolute",
        width: "1px",
        height: "8px",
        right: "6.5px",
        bottom: "2px",
        backgroundColor: (theme) => theme.palette.error.main,
        transform: "rotate(-45deg)"
    } : undefined
} : {}), { "& svg": {
        width: "12px",
        height: "12px"
    } }));
//# sourceMappingURL=ColorButton.js.map